<template>
  <div id="app">
    <Navbar />
    <Sidebar v-if="isLoggedIn" />
    <div :class="{'main-content': isLoggedIn}">
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Sidebar from '@/components/Sidebar.vue';
import { eventBus } from '@/eventBus';

export default {
  name: "App",
  components: {
    Navbar,
    Footer,
    Sidebar
  },
  data() {
    return {
      isLoggedIn: false,
      idleTimeout: null,
      idleLimit: 1 * 60 * 1000 // 1 menit
    }
  },
  created() {
    // Initialize auth state
    this.checkLoginStatus();
    
    // Listen for auth events
    eventBus.on('login-success', this.checkLoginStatus);
    eventBus.on('logout-success', this.checkLoginStatus);
    eventBus.on('register-success', this.checkLoginStatus);
  },
  beforeUnmount() {
    // Clean up event listeners
    eventBus.off('login-success', this.checkLoginStatus);
    eventBus.off('logout-success', this.checkLoginStatus);
    eventBus.off('register-success', this.checkLoginStatus);
    if (this.darkModeMediaQuery) {
      this.darkModeMediaQuery.removeEventListener('change', this.darkModeHandler);
    }
    // Cleanup idle/visibility listeners
    ['mousemove','keydown','mousedown','touchstart','scroll'].forEach(evt => {
      window.removeEventListener(evt, this.resetIdleTimer, true);
    });
    if (this.idleTimeout) clearTimeout(this.idleTimeout);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    checkLoginStatus() {
      this.isLoggedIn = !!localStorage.getItem('token');
    }
  },
  mounted() {
    // Set the document title before loading Home.vue or any other view
    document.title = 'Hobibaca - Baca Buku Online';

    // Idle detection
    this.resetIdleTimer = () => {
      if (this.idleTimeout) clearTimeout(this.idleTimeout);
      this.idleTimeout = setTimeout(() => {
        window.location.reload();
      }, this.idleLimit);
    };
    ['mousemove','keydown','mousedown','touchstart','scroll'].forEach(evt => {
      window.addEventListener(evt, this.resetIdleTimer, true);
    });
    this.resetIdleTimer();

    // Visibility detection
    this.handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        this.$eventBus.emit('tab-inactive');
      } else {
        this.$eventBus.emit('tab-active');
        this.resetIdleTimer();
      }
    };
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    this.darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    this.darkModeHandler = e => {
      if (e.matches) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    };
    if (this.darkModeMediaQuery) {
      this.darkModeMediaQuery.addEventListener('change', this.darkModeHandler);
    }
  },
};
</script>

<style>
body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Dark mode styles */
.dark {
  color-scheme: dark;
}

.dark body {
  background-color: #1a1a1a;
  color: #ffffff;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.main-content {
  margin-left: 250px; /* Sesuaikan dengan lebar sidebar */
  padding: 20px;
  min-height: calc(100vh - 60px); /* Sesuaikan dengan tinggi navbar */
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0; /* Remove sidebar margin on mobile */
  }
}
</style>
